import React from "react";

interface Props {
  title?: string;
}

class ChecklistItemSection extends React.Component<Props, {}> {

  public render() {
    const {title} = this.props;
    return (
      <>
        {title &&
            <h3 style={{marginBottom: 8, marginTop: 16, lineHeight: 1.5}}>
              {title}
            </h3>
        }
        {this.props.children}
      </>
    );
  }
}

export default ChecklistItemSection;


// WEBPACK FOOTER //
// ./src/checklist/layout/ChecklistItemSection.tsx